import { API } from "@/main";

const state = {
  allRolesAndPermissions: {
    loading: true,
    data: []
  },
  tabulatedPermissions: {}
};

const getters = {
  areAllRolesAndPermissionsLoading: state =>
    state.allRolesAndPermissions.loading,
  getAllRolesAndPermissions: state => state.allRolesAndPermissions.data,
  getAllPermissionsTabulatedByRole: state => role => {
    return state.tabulatedPermissions[role];
  }
};

const mutations = {
  SET_ALL_ROLES_PERMISSIONS_LOADING(state, loadingState) {
    state.allRolesAndPermissions.loading = loadingState;
  },
  SET_ALL_ROLES_PERMISSIONS_LIST(state, rolesAndPermissions) {
    state.allRolesAndPermissions.data = rolesAndPermissions;
  },
  SET_TABULATED_PERMISSIONS(state, { role, tabulatedPermissions }) {
    state.tabulatedPermissions[role] = tabulatedPermissions;
  }
};

const actions = {
  FETCH_ALL_ROLES_PERMISSIONS_LIST({ commit }) {
    commit("SET_ALL_ROLES_PERMISSIONS_LOADING", true);
    return new Promise((resolve, reject) => {
      API.acl.getAllRoles(
        "permissions, company",
        resp => {
          commit("SET_ALL_ROLES_PERMISSIONS_LIST", resp.data.data);
          commit("SET_ALL_ROLES_PERMISSIONS_LOADING", false);
          resolve(resp);
        },
        error => {
          commit("SET_ALL_ROLES_PERMISSIONS_LOADING", false);
          resolve(error);
        }
      );
    });
  },

  fetchAllPermissions({ commit }, fieldsToInclude) {
    return new Promise((resolve, reject) => {
      API.acl.getAllPermissions(
        fieldsToInclude,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  setTabulatedPermissions({ commit }, { role, tabulatedPermissions }) {
    commit("SET_TABULATED_PERMISSIONS", { role, tabulatedPermissions });
  },

  fetchPermissionsMatrix({ commit }, companyID, roleID = null) {
    return new Promise((resolve, reject) => {
      API.acl.getPermissionsMatrix(
        companyID,
        roleID,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error)
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/permissions.js